import Form from "./form"
import Nav from "./nav"
import Datetimepicker from "./datetimepicker"
import PrivacyPolicy from "./privacy_policy"
import Slider from "./slider"

document.addEventListener("DOMContentLoaded", function () {
  Form(jQuery)
  Nav(jQuery)
  Datetimepicker(jQuery)
  PrivacyPolicy(jQuery)
  Slider(jQuery)
})
